module.exports = __webpack_public_path__ + "img/057bcc0.webp";